export const describeWalletTransaction = (referenceKey: string): string => {
  if (referenceKey.startsWith('campaign:')) return 'Campaign earning';
  if (referenceKey.startsWith('sub:')) return 'Plan paid from wallet';
  if (referenceKey.startsWith('stripe-upgrade:')) return 'Subscription upgrade from credits';
  if (referenceKey.startsWith('stripe-invoice:')) return 'Subscription renewal from credits';
  if (referenceKey.startsWith('withdraw:')) return 'Withdrawal paid out';
  return 'Wallet transaction';
};

export const formatWalletDate = (value: string): string => new Date(value).toLocaleDateString();
